import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { MayanHeroes_ResponsivePIXIApp } from "../MayanHeroes/game_ResponsivePIXIApp";

export class MayanHeroesLink_ResponsivePIXIApp extends MayanHeroes_ResponsivePIXIApp {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "MayanHeroesLink");
    }
}